<div class="modal-header">
  <div class="modal-title">
    @if (title) {
      <h3 class="mb-0">{{ title }}</h3>
    }
    @if (message) {
      <p class="modal-subtitle mb-0">{{ message }}</p>
    }
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  @for (AdditionalMessage of AdditionalMessages; track AdditionalMessage) {
    <p
      class="ccd-extra-message"
      [ngStyle]="AdditionalMessage.style"
      [class]="AdditionalMessage.classes"
    >
      {{ AdditionalMessage.text }}
    </p>
  }

  @if (enableFiltering || showSelectAllButton) {
    <div class="ccd-toolbar">
      @if (enableFiltering) {
        <input
          type="text"
          [(ngModel)]="filterText"
          class="form-control ccd-filter"
          placeholder="Search…"
          (keyup)="filter(filterText)"
        />
      }
      @if (showSelectAllButton) {
        <button
          type="button"
          class="btn btn-outline btn-sm"
          (click)="handleAllCardSelections()"
        >
          {{ areAllCardsSelected ? 'Deselect all' : 'Select all' }}
        </button>
      }
    </div>
  }

  <div class="ccd-card-column">
    <app-card-column
      [enableSelection]="selectionModel ? selectionModel.selectionType : false"
      (cardClick)="cardClicked($event)"
      [borderClassArray]="[
        'column-border-left',
        'column-border-right',
        'column-border-top',
        'column-border-bottom'
      ]"
      class="card-column"
      [cardCollection]="cardCollection"
    ></app-card-column>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      {{ cancelButtonText }}
    </button>
    <button type="button" class="btn btn-primary" (click)="continue()">
      {{ continueButtonText }}
    </button>
  </div>
</div>
